import * as React from "react";

import { Nullable } from "types";

interface PropsType {
  children?: JSX.Element;
  errors: string[];
  title?: string;
}

function Title({ title }: { title: string }): Nullable<JSX.Element> {
  if (!title) return null;

  return (
    <h2>
      <i className="fas fa-exclamation-triangle" />
      <span>{title}</span>
    </h2>
  );
}

export default function ErrorExplanation(
  props: PropsType,
): Nullable<JSX.Element> {
  const { children, errors, title } = props;
  if (!errors || !errors.length) return null;

  const Errors = errors.map((e) => (
    <li key={e}>
      <i className="fas fa-exclamation-triangle" />
      <span>{e}</span>
    </li>
  ));

  return (
    <div id="error-explanation">
      <Title {...{ title }} />
      <ul>{Errors}</ul>
      {children}
    </div>
  );
}
